import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../../../components/InnerHero";
import {
  ArrowLeft,
  FlaskConical,
  Images,
  Atom,
  BookOpen,
} from "lucide-react";

const infrastructureImages = [
  {
    src: "/Infrastructure/BSH/BSH (1).png",
   // title: "Physics Laboratory",
   // alt: "Physics Laboratory",
  },
  
  {
    src: "/Infrastructure/BSH/BSH (4).png",
    //title: "Mathematics Learning Centre",
    //alt: "Mathematics Learning Centre",
  },
  

];

const facilities = [
  "Physics Laboratory",
  "Chemistry Laboratory",
  "Language Laboratory",
  "Mathematics Learning Centre",
  "Smart Classrooms",
  "Research Facilities",
  "Seminar Facilities",
  "Computing Support",
];

const BSHInfrastructure = () => (
  <main>
    <InnerHero
      title="Physics Department Infrastructure"
      image="/Infrastructure/BSH/BSH (1).png"
      breadcrumbs={[
        { label: "Academics", to: "/academics" },
        { label: "Basic Science", to: "/programme/bsh" },
        { label: "Infrastructure" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link
          to="/programme/bsh"
          className="inline-flex items-center gap-2 uppercase hover:underline"
        >
          <ArrowLeft size={14} />
          Back to Basic Science
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} />
                  Infrastructure Gallery
                </h2>

                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  Laboratories and learning facilities of the Basic Science Department
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {infrastructureImages.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  {/* <figcaption className="px-4 py-3">
                    <span className="text-xs uppercase tracking-widest text-brand font-semibold">
                      {image.title}
                    </span>
                  </figcaption> */}
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <FlaskConical size={22} />
              Facilities
            </h2>

            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold">
              Infrastructure Facts
            </h4>

            <div className="mt-3 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Atom size={14} className="text-brand" />
                <span>
                  Physics Lab: <strong>Available</strong>
                </span>
              </div>

              <div>
                Chemistry Lab: <strong>Available</strong>
              </div>

              <div>
                Language Lab: <strong>Available</strong>
              </div>

              <div>
                Mathematics Centre: <strong>Available</strong>
              </div>

              <div>
                Smart Classrooms: <strong>Available</strong>
              </div>
            </div>

            <Link
              to="/programme/bsh"
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold hover:bg-brand-dark transition"
            >
              Department Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold mb-3">
                Learning Facilities
              </h4>

              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {[
                  "Physics Lab",
                  "Chemistry Lab",
                  "Language Lab",
                  "Mathematics Centre",
                  "Smart Classrooms",
                  "Seminar Hall",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <BookOpen size={12} className="text-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default BSHInfrastructure;
